import React, { useEffect, useState } from "react";
import './ClientsLogoTestimonials.css';
import logo1 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo2 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo3 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo4 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo5 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo6 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo7 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo8 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo9 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo10 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo11 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo12 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo13 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo14 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo15 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo16 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo17 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo18 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo19 from '../../assets/images/logo_sarsindialiaison.jpg';
import logo20 from '../../assets/images/logo_sarsindialiaison.jpg';

const clientLogos = [
    { name: "Company 1", logo: logo1, description: "Project 1 Description" },
    { name: "Company 2", logo: logo2, description: "Project 2 Description" },
    { name: "Company 3", logo: logo3, description: "Project 3 Description" },
    { name: "Company 4", logo: logo4, description: "Project 4 Description" },
    { name: "Company 5", logo: logo5, description: "Project 5 Description" },
    { name: "Company 6", logo: logo6, description: "Project 6 Description" },
    { name: "Company 7", logo: logo7, description: "Project 7 Description" },
    { name: "Company 8", logo: logo8, description: "Project 8 Description" },
    { name: "Company 9", logo: logo9, description: "Project 9 Description" },
    { name: "Company 10", logo: logo10, description: "Project 10 Description" },
    { name: "Company 11", logo: logo11, description: "Project 11 Description" },
    { name: "Company 12", logo: logo12, description: "Project 12 Description" },
    { name: "Company 13", logo: logo13, description: "Project 13 Description" },
    { name: "Company 14", logo: logo14, description: "Project 14 Description" },
    { name: "Company 15", logo: logo15, description: "Project 15 Description" },
    { name: "Company 16", logo: logo16, description: "Project 16 Description" },
    { name: "Company 17", logo: logo17, description: "Project 17 Description" },
    { name: "Company 18", logo: logo18, description: "Project 18 Description" },
    { name: "Company 19", logo: logo19, description: "Project 19 Description" },
    { name: "Company 20", logo: logo20, description: "Project 20 Description" },
    // Add more logos as needed
];

export default function ClientsLogoTestimonials() {
    const [isVisible, setIsVisible] = useState(false);

    const checkIfInView = () => {
        const section = document.querySelector('.client-logos');
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
            setIsVisible(true);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', checkIfInView);
        checkIfInView();

        return () => window.removeEventListener('scroll', checkIfInView);
    }, []);

    return (
        <section className={`client-logos ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="section-title_oo9">Our Trusted Clients</h2>
            <p className="section-subtitle_oo9">
                We are proud to work with some of the industry's leading brands.
            </p>

            <div className="logo-grid">
                {clientLogos.map((client, index) => (
                    <div key={index} className="logo-item">
                        <div className="logo-container">
                            <img src={client.logo} alt={client.name} className="logo" />
                            <div className="tooltip">
                                <span className="tooltip-text">{client.description}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
